<template>
  <PillsTabs
    v-editable="blok"
    :items="blok.items"
    :secondary-color="blok.secondary_color"
    :pills-under-sections="blok.pills_under_sections"
    :duration="blok.duration ? Number(blok.duration) : 10"
  />
</template>

<script lang="ts" setup>
import type { SbPillsTabsStoryblok } from '@/types'

interface Props {
  blok: SbPillsTabsStoryblok
}

defineProps<Props>()
</script>
